import Image from "components/Elements/Image/Image";
import { useContent } from "contexts/contentContext/contentContext";

const EnterpriseCardFeature = () => {
  const { getHtmlByKey } = useContent();
  return (
    <div className="enterprise-custom-elem">
      <Image name="plans/enterprise-img" ext="png"/>
      <div className="enterprise-image"></div>
      {getHtmlByKey("enterprise-card-text")}
      <div className="eneterprise-background-gradient"></div>
    </div>
  );
};

export default EnterpriseCardFeature;
